import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route } from '../constants';
import { APP_DOMAINS } from '~/types';

interface IconNavigationProps extends Route {
  setAppDomain: React.Dispatch<React.SetStateAction<APP_DOMAINS | null>>;
}

export const IconButton = ({
  icon,
  label,
  setAppDomain,
}: IconNavigationProps) => {
  const [t] = useTranslation('navigation');

  return (
    <button
      className="flex w-full cursor-pointer flex-col items-center gap-1 rounded-md p-1 transition-all duration-150 hover:scale-110 hover:bg-custom-info-100 hover:shadow-sm  focus:bg-custom-info-100"
      onClick={() => setAppDomain(label as APP_DOMAINS)}
    >
      {typeof icon === 'string' ? (
        <img src={icon} className="h-5 w-5" alt={label} />
      ) : (
        React.createElement(icon as React.ComponentType<any>, {
          className: 'h-5 w-5 text-current',
          'aria-label': label,
        })
      )}
      <label className="text-[9px]">{t(`menu_${label}`)}</label>
    </button>
  );
};
